import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function superadminGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (store.getters['permissions/isSuperAdmin'] || store.getters['permissions/isAccountManager']) {
    return next()
  }

  return next({ name: 'unauthorized' })
}

export default superadminGuard
